module.exports = __webpack_public_path__ + "img/home_icon4.59e806e3.png";